package com.essntl.uikit.components.dialog

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsAlertSaveDialog(
    onDismissRequest: () -> Unit,
    title: String,
    onReturn: () -> Unit,
) {
    EsDialog(
        title = "Save $title",
        onDismissRequest = onDismissRequest,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier
                .fillMaxWidth()
                .background(color = Color.White),
        ) {
            Text(
                text = "If you navigate back without saving, any updates made to your $title will be lost.",
                style = MaterialTheme.esTypography.p1Regular16.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
                modifier = Modifier.padding(2.5.spacing),
            )

            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(2.5.spacing),
            ) {
                EsLargePrimaryButton(
                    onClick = {
                        onDismissRequest()
                        onReturn()
                    },
                    text = "Return",
                    enabled = true,
                    modifier = Modifier
                        .weight(1F),
                )
                Spacer(modifier = Modifier.width(width = 1.5.spacing))
                EsLargeSecondaryButton(
                    onClick = {
                        onDismissRequest()
                    },
                    text = "Cancel",
                    enabled = true,
                    modifier = Modifier
                        .weight(1F),
                )
            }
        }
    }
}